import { Link } from 'react-router-dom';

export default function FooterLinksColumn({ heading, links }) {
  return (
    <ul className="space-y-2.5">
      {links.map(([label, href]) => (
        <li key={href}>
          <Link
            to={href}
            className="text-sm transition-colors duration-200 hover:text-white"
            style={{ color: '#94A3B8' }}
          >
            {label}
          </Link>
        </li>
      ))}
    </ul>
  );
}

export function FooterColumnHeading({ children }) {
  return (
    <h3 className="text-xs font-semibold uppercase tracking-widest mb-5" style={{ color: '#475569' }}>
      {children}
    </h3>
  );
}
